import ApiUrl from 'enum/api-url.enum';
import httpService from 'services/http/http.service';

function apiKeyValidation(key) {
  return httpService.registration(ApiUrl.APIKEYVALIDATION + '?apikey=' + key);
}

const obj = { apiKeyValidation };

export default obj;
